import React, { useEffect, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { ImageOff } from 'lucide-react';
import { fetchOrders } from '../../store';
import { isMandatoryProfileGateRole } from '../../utils/profileCompletion';
import './MyOrders.css';

const orderThumbIconProps = { size: 36, strokeWidth: 1.75 };

const MyOrders = () => {

    const dispatch = useDispatch();
    const user = useSelector((state) => state.user);
    const allOrders = useSelector((state) => state.orders?.items || []);
    const products = useSelector((state) => state.products?.items || []);
    const [filter, setFilter] = useState('all');
    const userId = user?._id || user?.id;
    const orders = userId ? allOrders.filter(order => order.user === userId) : allOrders;
    const filteredOrders = filter === 'all' ? orders : orders.filter(order => (order.orderStatus || '').toLowerCase() === filter);
    const orderStatusMap = {
        pending: 'Pending',
        processing: 'Processing',
        shipped: 'Shipped',
        delivered: 'Delivered',
        cancelled: 'Cancelled',
    };

    const getImageFromProduct = (productId) => {
        const product = products.find(p => p._id === productId);
        return product ? product.images[0] : ''; // Fallback image if product not found
    };

    useEffect(() => {
        if (userId && user && !user.loading && isMandatoryProfileGateRole(user)) {
            dispatch(fetchOrders(userId));
        }
    }, [userId, user?.role, user.loading, dispatch]);

    return (
        <main className="orders-content">
            <section className="orders-section">
                <div className="my-order-section-header">
                    <div>
                        <h2 className="my-order-section-title">My Orders</h2>
                        <p className="my-order-section-subtitle">Track and manage your eco-friendly bag orders</p>
                    </div>
                </div>

                <div className="filter-tabs">
                    {['all', "pending", "processing", "shipped", "delivered", "cancelled"].map((orderStatus) => (
                        <button
                            key={orderStatus}
                            className={`filter-tab${filter === orderStatus ? ' active' : ''}`}
                            data-filter={orderStatus}
                            onClick={() => setFilter(orderStatus)}
                        >
                            {orderStatus === 'all' ? 'All Orders' : orderStatusMap[orderStatus]}
                        </button>
                    ))}
                </div>

                {filteredOrders?.length === 0 && (
                    <div className="my-order-card empty">
                        <div className="my-order-header">
                            <div>No orders found for this filter.</div>
                        </div>
                    </div>
                )}

                {filteredOrders?.map((order, idx) => (
                    <div className="my-order-card" key={order._id || idx}>
                        <div className="my-order-header">
                            <div>
                                <div className="my-order-number">Order #{order.orderId || idx + 1}</div>
                                <div className="my-order-date">{order.createdAt ? new Date(order.createdAt).toLocaleDateString() : '-'}</div>
                            </div>
                            <div className={`my-order-orderStatus orderStatus-${(order.orderStatus || '').toLowerCase()}`}>{order.orderStatus || '-'}</div>
                        </div>

                        <div className="my-order-items">
                            {order.items?.map((item, iidx) => (
                                <div className="my-order-item" key={iidx}>
                                    <div className="item-image">
                                        {getImageFromProduct(item.productId) ? (
                                            <img src={getImageFromProduct(item.productId)} alt={item.name} style={{ width: "100%", height: "100%", objectFit: "contain" }} />
                                        ) : (
                                            <span className="my-order-image-placeholder" aria-hidden>
                                                <ImageOff {...orderThumbIconProps} />
                                            </span>
                                        )}
                                    </div>
                                    <div className="item-details">
                                        <div className="item-name">{item.name}</div>
                                        <div className="item-qty">Size: {item.bagSize?.cm}</div>
                                        <div className="item-qty">GSM: {item.specifications?.gsm}</div>
                                        <div className="item-qty">Quantity: {item.quantity}</div>
                                    </div>
                                    <div className="item-price">
                                        ₹{item.price?.amount ? (Number(item.price.amount) * item.quantity).toFixed(2) : '0.00'}
                                    </div>
                                </div>
                            ))}
                        </div>

                        <div className="my-order-footer">
                            <div className="my-order-total">Total: ₹{order.totals?.grandTotal?.toFixed(2) || '0.00'}</div>
                            <div className="my-order-actions">
                                {/* {order.orderStatus?.toLowerCase() === 'processing' && <button className="btn-sm btn-primary">Track Order</button>}
                                {order.orderStatus?.toLowerCase() === 'processing' && <button className="btn-sm btn-secondary">Contact Support</button>}
                                {order.orderStatus?.toLowerCase() === 'shipped' && <button className="btn-sm btn-primary">Track Order</button>}
                                {order.orderStatus?.toLowerCase() === 'shipped' && <button className="btn-sm btn-secondary">View Details</button>}
                                {order.orderStatus?.toLowerCase() === 'delivered' && <button className="btn-sm btn-primary">Reorder</button>}
                                {order.orderStatus?.toLowerCase() === 'delivered' && <button className="btn-sm btn-secondary">Leave Review</button>}
                                {order.orderStatus?.toLowerCase() === 'cancelled' && <button className="btn-sm btn-secondary">Contact Support</button>}
                                <button className="btn-sm btn-secondary">Download Invoice</button> */}
                            </div>
                        </div>
                    </div>
                ))}
            </section>
        </main>
    );
};

export default MyOrders;